import '../components/LoadingIndicator/index.js';
class LoadingIndicatorController {
    hide() {
        this.#el.hide();
    }
    register(el) {
        this.#el = el;
    }
    show() {
        this.#el.show();
    }
    #el;
}
export const loadingIndicator = new LoadingIndicatorController();
